import { Action, combineReducers, configureStore, ThunkAction } from "@reduxjs/toolkit";
import AppReducer from "components/app/App.slice";
import FiltersReducer from "components/common/Filters/Filters.slice";
import productsReducer from "components/common/plans/plans.slice";
import SnackbarSlice from "components/common/Snackbar/snackbar.slice";
import AbovePropertyReducer from "components/features/AboveProperty/AboveProperty.slice";
import CorpDashboardSlice from "components/features/Corp/CorpUser.Slice";
import DashboardSlice from "components/features/dashboard/Dashboard.slice";
import GlobalSearchSlice from "components/features/GlobalSearch/GlobalSearch.slice";
import IndividualPropertyReducer from "components/features/IndividualProperty/IndividualProperty.slice";
import UserDashboardReducer from "components/features/InncodeUsers/userdashboard.slice";
import BookmarkedPlanReducer from "components/features/library/Bookmark/Bookmark.slice";
import individualActionSlice from "components/features/library/functionalArea/individualAction.slice";
import FunctionalAreaReducer from "components/features/library/libraryHall/Hall.slice";
import SuggestedPlanReducer from "components/features/library/Suggested/Suggested.slice";
import MyPlanDetailsReducer from "components/features/MyPlanDetails/MyPlanDetails.slice";
import myplansReducer from "components/features/MyPlans/myplans.slice";
import NotificationsSlice from "components/features/Notifications/Notifications.slice";
import OnboardingSlice from "components/features/Onboarding/Onboarding.slice";
import PlanDetailsReducer from "components/features/planDetails/PlanDetail.slice";
import ProgressSlice from "components/features/Progress/Progress.slice";
import RecommendationsSlice from "components/features/Recommendations/Recommendations.slice";
import SMEReducer from "components/features/SME/sme.slice";
import UserViewReducer from "components/features/UserView/UserView.slice";
import FormSlice from "./forms.slice";

export const rootReducer = combineReducers({
  app: AppReducer,
  plans: productsReducer,
  functionalAreas: FunctionalAreaReducer,
  planDetails: PlanDetailsReducer,
  bookmarkedPlans: BookmarkedPlanReducer,
  myplans: myplansReducer,
  myPlanDetails: MyPlanDetailsReducer,
  formDetails: FormSlice,
  Dashboard: DashboardSlice,
  CorpDashboard: CorpDashboardSlice,
  suggestedPlans: SuggestedPlanReducer,
  onboardingResponse: OnboardingSlice,
  Recommendations: RecommendationsSlice,
  individualAction: individualActionSlice,
  Notifications: NotificationsSlice,
  snackbarDetails: SnackbarSlice,
  sme: SMEReducer,
  userDashboard: UserDashboardReducer,
  aboveProperty: AbovePropertyReducer,
  globalSearch: GlobalSearchSlice,
  userView: UserViewReducer,
  individualProperty: IndividualPropertyReducer,
  filters: FiltersReducer,
  progress: ProgressSlice
});

export const store = configureStore({
  reducer: rootReducer
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<ReturnType, RootState, unknown, Action<string>>;
